import { Image, LinkBase, Text } from '@belong/ui';
import clsx from 'clsx';
import { REFRESH_MIAMI_BANNER_STRINGS } from './refresh-miami-banner-strings';
import css from './refresh-miami-banner.module.css';

export function RefreshMiamiBanner() {
  return (
    <LinkBase href={REFRESH_MIAMI_BANNER_STRINGS['link']} target="_blank">
      <div
        className={clsx(
          css.container,
          'border-gray bg-light-gray duration-hover hover:border-dark-gray group mx-auto w-full overflow-hidden rounded border border-solid transition-all hover:cursor-pointer',
        )}
      >
        <div className="flex flex-col lg:flex-row-reverse">
          <div
            className={clsx(
              css.imageContainer,
              'border-gray duration-hover group-hover:border-dark-gray flex flex-row border-solid transition-all',
            )}
          >
            <Image
              src="/homeowner-lp/refresh_miami_banner_image_m.png"
              alt={REFRESH_MIAMI_BANNER_STRINGS['image.alt']}
              className="block object-cover lg:absolute lg:hidden"
            />
            <Image
              src="/homeowner-lp/refresh_miami_banner_image.png"
              alt={REFRESH_MIAMI_BANNER_STRINGS['image.alt']}
              className="absolute hidden object-cover lg:relative lg:block"
            />
          </div>
          <div className="px-2sm py-sm lg:px-xl container flex flex-col items-center text-center lg:items-start lg:text-left">
            <div className={clsx(css.logoImage, 'mb-2sm max-h-auto lg:mb-2xs')}>
              <Image
                src="homeowner-lp/refresh_miami_banner_logo.png"
                alt={REFRESH_MIAMI_BANNER_STRINGS['logo.alt']}
              />
            </div>
            <Text variant="body" className="text-navy sm:absolute sm:hidden">
              {REFRESH_MIAMI_BANNER_STRINGS['text']}
            </Text>
            <Text
              variant="h3"
              className="text-navy absolute hidden sm:relative sm:block"
            >
              {REFRESH_MIAMI_BANNER_STRINGS['text']}
            </Text>
            <Text
              variant="body"
              fontWeight="semibold"
              className={clsx(
                'mt-sm text-navy duration-hover group-hover:text-dark-navy lg:mt-md transition-all lg:self-end',
              )}
            >
              {REFRESH_MIAMI_BANNER_STRINGS['read_more']}
            </Text>
          </div>
        </div>
      </div>
    </LinkBase>
  );
}
